import { LoginModel } from './models/login.model';
import { AuthMeResponse, AuthUserData } from './models';
import { Error } from '../../../common/constants/error';

export class AuthLogin {
  public static readonly type = '[Auth] Login';

  constructor(public payload: LoginModel) {}
}

export class AuthSSOLogin {
  public static readonly type = '[Auth] SSO Login';

  constructor(public payload: string) {}
}

export class AuthSessionLogin {
  public static readonly type = '[Auth] Session Login';

  constructor(public payload: string) {}
}

export class AuthRefreshToken {
  public static readonly type = '[Auth] Refresh Token';
}

export class AuthResetPassword {
  public static readonly type = '[Auth] Reset Password';

  constructor(public payload: string) {}
}

export class AuthLogout {
  public static readonly type = '[Auth] Logout';

  constructor(public payload?: string) {}
}

export class AuthLogoutWithSkid {
  public static readonly type = '[Auth] Skid Logout';
}

export class AuthSetUser {
  public static readonly type = '[Auth] Set User';

  constructor(public payload: AuthMeResponse) {}
}

export class AuthRedirectUserToDashboard {
  public static readonly type = '[Auth] Redirect User to Dashboard';
}

export class AuthRedirectUserToChangePassword {
  public static readonly type = '[Auth] Redirect User to Change Password';
}

export class AuthClearStorage {
  public static readonly type = '[Auth] Clear Storage';
}

export class AuthError {
  public static readonly type = '[Auth] Error';

  constructor(public payload: Error) {}
}

export class AuthSetInitialState {
  public static readonly type = '[Auth] Set Initial State';
}

export class AuthInit {
  static readonly type = '[Auth] Init';
}

export class AuthSetExpiresAt {
  static readonly type = '[Auth] Set ExpiresAt';

  constructor(public expiresAt: number | null) {}
}

export class AuthPatchUserData {
  static readonly type = '[Auth] Patch User Data';

  constructor(public payload: Partial<AuthUserData>) {}
}

export class AuthReloadUserData {
  static readonly type = '[Auth] Reload User Data';
}

export class AuthShowMapsPluginDialog {
  static readonly type = '[Auth] Show Maps Plugin Dialog';

  constructor(public payload: boolean) {}
}
